import React from "react";
import Dropzone from "react-dropzone";

// for profile picture
class ImageUpload extends React.Component {
    state = { warningMsg: "" };

    onDrop = (accepted, rejected) => {
        if (Object.keys(rejected).length !== 0) {
            const message = "Please submit valid file type";
            this.setState({ warningMsg: message });
        } else {
            const blobPromise = new Promise((resolve, reject) => {
                const reader = new window.FileReader();
                reader.readAsDataURL(accepted[0]);
                reader.onloadend = () => {
                    const base64data = reader.result;
                    resolve(base64data);
                };
            });
            blobPromise.then((value) => {
                accepted[0].base64 = value;
                this.props.addFile(accepted);
                this.setState({ warningMsg: "" });
            });
        }
    };

    render() {
        const { files, index, size,angle,create} = this.props;

        const thumbsContainer = (size === 'is-big') ? {
            width: "240px",
            height: "320px",
            objectFit: "cover",
            objectPosition: "center",
        } : {
            width: "120px",
            height: "160px",
            objectFit: "cover",
                objectPosition: "center",

        };

        const imageStyle = (size === 'is-big') ? {
            width: "240px",
            height: "320px",
            objectFit: "cover",
            margin: "0 auto",
            objectPosition: "center",
            background: "#d8d8d8",
        } : {
            width: "120px",
            height: "160px",
            objectFit: "cover",
            margin: angle ? '':"0 auto",
            objectPosition: "center",
            background: "#d8d8d8",
            marginLeft:angle === 'Back' && create ? '20%':3
        };

        const thumbs = files.map((file) => (
            <img
                style={thumbsContainer}
                key={index}
                src={file.preview}
                alt="profile"
            />
        ));

        const render =
            Object.keys(files).length !== 0 ? (
                files.map((file) => <aside key={index}>{thumbs}</aside>)
            ) : (
                    <>
                    
                        <p className="hello" />
                        {
                        angle && <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '160px', cursor: 'pointer' }}>
                                    <p style={{fontWeight:'bold',fontSize:'20px'}}>{angle}</p>
                                </div> 
                        }
                        
                    </>
            );

        return (
            <div>
                <p>{this.state.warningMsg}</p>
                <Dropzone
                    style={imageStyle}
                    disabled={this.props.disabled}
                    multiple={false}
                    accept="image/*"
                    onDrop={(accepted, rejected) => this.onDrop(accepted, rejected)}
                >
                    {({ isDragAccept, isDragReject, acceptedFiles, rejectedFiles }) => {
                        // for drag and drop warning statement
                        
                        if (isDragReject) return "Please submit a valid file";
                        
                        return render;
                    }}
                </Dropzone>
            </div>
        );
    }
}

export default ImageUpload;
